import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { PartnerAuthProvider } from "./context/PartnerAuthContext";
import "../src/styles/suite.css";
import "./styles/index.css";
import "../shared/phone/phone.css";
import "./styles/phone.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <PartnerAuthProvider>
          <App />
        </PartnerAuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
